import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal, Button, Form } from 'react-bootstrap';

import ErrorAlert from '../../Alerts/ErrorAlert';
import { RenderIf } from '../../utils/RenderIf';

import { GroupsFechtAPI } from '../../../api/Groups';
import { TaxesFetchAPI } from '../../../api/Taxes';
import { checkUserModules } from '../../utils/CheckUserModules';
//icons
import add from '../../img/icons/add-product.png'

function ModalCreateGroup({ setEventHandler, user, isSeparatorPage }) {
    const [showModal, setShowModal] = useState(false)
    const [typeCategory, setTypeCategory] = useState([])
    const [taxes, setTaxes] = useState([])
    const [upc_input, setUpc_input] = useState('')
    const [taxesSelect, setTaxesSelect] = useState([])
    const [imgpreview, setImgpreview] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([])
    let token = localStorage.getItem("x-access-token")



    //Function to register the product 
    const submit = async (e) => {
        e.preventDefault();
        let createGroup = {};
        const form = new FormData(e.target);
        form.append("business_id", user.business_id);
        //We check if the user is creating a separator or a product
        if (isSeparatorPage === undefined || !isSeparatorPage) {
            if (user.business.posIntegration !== undefined) {
                form.append("pos_integration", user.business.posIntegration);
            }
        } else {
            form.append("type", "separator");
        }

        selectedFiles.forEach((file) => {
            form.append("files", file);
        });
        try {
            //We update the data 
            let response = await GroupsFechtAPI.newGroup(form, token);
            //We show the success alert 
            setTaxesSelect([])
            ErrorAlert('', isSeparatorPage ? "Separador creado " : 'Producto creado con exito', 'success')
            setEventHandler(1);
            setImgpreview('')
            setShowModal(false);
        } catch (err) {
            ErrorAlert(err.response.data.error, 'Error de registro', 'error')
            console.log(err.response.data.error)
        }
    }

    //Function to get the taxes
    const getTaxes = async () => {
        try {
            const response = await TaxesFetchAPI.getTaxes(token);
            setTaxes(response.data.data)
            console.log(response.data.data);

        } catch (err) {
            console.log(err);
        }
    }
    //Function to change the image
    const changeimg = (e) => {
        const files = Array.from(e.target.files || []);
        setSelectedFiles(files);

        const previews = files.map((file) => URL.createObjectURL(file));
        setImgpreview(previews);
    }

    //filter checkbox in state true and save in state array
    const getChecked = (event) => {
        let dataTaxes = JSON.parse(event.target.value)


        if (event.target.checked == true) {
            setTaxesSelect([...taxesSelect, dataTaxes])
        } else if (event.target.checked == false) {
            for (let i = 0; i < taxesSelect.length; i++) {
                if (taxesSelect[i] == dataTaxes) {
                    taxesSelect.splice(i, 1)
                }
            }
        }
    }
    // Imagen por defecto
    const fileInputRef = useRef(null);
    const handleClick = () => {
        fileInputRef.current.click(); // Dispara el clic sobre el input
    };
    return (
        <>
            <button className={'btn-add-product-list  rounded-4  pulse mt-4 py-4 w-100'}
                onClick={() => (setShowModal(true), getTaxes())}
            >
                {/**Check user permition to create products */}
                <div className='d-flex justify-content-center '>
                    <img src={add} alt="Add" />
                </div>

                <div className="text-center ">
                    <span className='fw-bold'>{!isSeparatorPage || isSeparatorPage === undefined ? "Agregar Nuevo Producto" : "Agregar Nuevo separador"}</span>
                </div>
            </button>

            <Modal
                show={showModal}
                onHide={() => (setShowModal(false), setImgpreview([]), setSelectedFiles([]))}
                size='xl'
                centered>
                <Modal.Body>
                    <div className='text-center p-2'>
                        <h2 className='h4 fw-bold text-primary'>
                            {!isSeparatorPage || isSeparatorPage === undefined ? "Crear Nuevo Producto" : "Crear separador"}
                        </h2>
                    </div>
                    {/* <RenderIf isTrue={imgpreview != ''}> */}
                    <Form.Label className='text-black fw-semibold'>{!isSeparatorPage || isSeparatorPage === undefined ? "Imagen del producto" : "Imagen del separador"}</Form.Label>
                    <div className='border rounded-4' ref={fileInputRef} onClick={handleClick} >
                        <div className='d-flex align-item-center justify-content-center'>
                            <div className='d-flex flex-wrap gap-2 justify-content-center p-3'>
                                {imgpreview.length > 0 ? (
                                    imgpreview.map((img, index) => (
                                        <img
                                            key={index}
                                            className='imgEditModal'
                                            src={img}
                                            alt={`preview-${index}`}
                                        />
                                    ))
                                ) : (
                                    <span className="text-muted">No hay imágenes seleccionadas</span>
                                )}
                            </div>
                        </div>

                        <div className='d-flex align-item-center justify-content-center m-3' htmlFor="upload-button">
                            <label >
                                <h5 className="text-center">Seleccione una imagen</h5>
                            </label>
                        </div>
                    </div>


                    <Form.Group controlId="formFileMultiple" className="mb-3">
                        <Form.Control
                            type="file"
                            id="upload-button"
                            placeholder="Imagen"
                            name="files"
                            multiple
                            accept="image/*"
                            onChange={changeimg}
                            ref={fileInputRef}
                        />
                    </Form.Group>
                    <Form
                        className="needs-validation row"
                        onSubmit={submit}


                    >
                        <Form.Group className="mb-3 col-4">
                            <Form.Label className='text-black fw-semibold'>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nombre del producto"
                                name="name"
                                required
                                autoFocus
                            />
                        </Form.Group>
                        <RenderIf isTrue={isSeparatorPage === undefined || !isSeparatorPage}>

                            <Form.Group className="mb-3 col-4" >
                                <Form.Label className='text-black fw-semibold' >Precio</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="$0.00"
                                    name="price"
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3 col-4" >
                                <Form.Label className='text-black fw-semibold' >Upc: mínimo 6 caracteres</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="0000000000000000"
                                    name="upc_code"
                                    onChange={(e) => setUpc_input(e.target.value)}

                                />
                            </Form.Group>
                        </RenderIf>
                        <Form.Group className="mb-3 col-12" >
                            <Form.Label className='text-black fw-semibold' >Descripción</Form.Label>
                            <Form.Control as="textarea" rows={3}
                                placeholder="Descripcion del producto"
                                name="description"
                                required
                            />
                        </Form.Group>
                        <RenderIf isTrue={isSeparatorPage === undefined || !isSeparatorPage}>
                            <Form.Group className="mb-3 col-4" >
                                <Form.Label className='text-black fw-semibold' >Preparación</Form.Label>
                                <Form.Select aria-label="" name="preparation">
                                    <option value="0">No</option>
                                    <option value="1">Si</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3  col-4" >
                                <Form.Label className='text-black fw-semibold' >Producto destacado/favorito</Form.Label>
                                <Form.Select aria-label="" name="favorite">
                                    <option value="0">No</option>
                                    <option value="1">Si</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3 col-4" >
                                <Form.Label className='text-black fw-semibold' >Habilitar producto para venta cruzada</Form.Label>
                                <Form.Select aria-label="" name="cross_sell">
                                    <option value="0">No</option>
                                    <option value="1">Si</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3 col-4" >
                                <Form.Label className='text-black fw-semibold' >Tipo de producto</Form.Label>
                                <Form.Select aria-label="" name="type">
                                    <option value="normal">Normal</option>
                                    <option value="reservable">Reservable</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3 col-12" >
                                <Form.Label className='text-black fw-semibold' >Impuestos </Form.Label>
                                <div>
                                    {taxes.map((tax, index) => (
                                        <>
                                            <Form.Check
                                                inline
                                                label={tax.tax + "-  " + tax.percentage}
                                                name="taxes"
                                                type='checkbox'
                                                value={JSON.stringify(tax.id)}
                                                onChange={(e) => getChecked(e)}
                                                id={`tax${tax.id}`}
                                            />
                                        </>
                                    ))}
                                </div>
                            </Form.Group>

                            <RenderIf isTrue={checkUserModules('pos_integrations_module', user.modules) !== -1 && user.business.posIntegration !== undefined}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Referencia externa</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Referencia externa"
                                        name="external_reference"
                                        required
                                    />
                                </Form.Group>
                            </RenderIf>
                            <Form.Group className="mb-3 col-12" >
                                <Form.Label className='text-black fw-semibold' >Terminos y condiciones</Form.Label>
                                <Form.Control as="textarea" rows={3}
                                    placeholder="Terminos y condiciones del producto"
                                    name="condition_terms"
                                />
                            </Form.Group>
                            <Form.Group controlId="formFileMultiple" className="mb-3">
                                <Form.Label></Form.Label>
                                <Form.Control type="file"
                                    id="upload-button"
                                    placeholder="Imagen"
                                    name="files"
                                    onChange={(e) => changeimg(e)}
                                />
                            </Form.Group>
                        </RenderIf>
                        <div className="mt-3 d-flex justify-content-end">
                            <Button size="sm" variant="success" type="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => (setShowModal(false), setImgpreview([]), setSelectedFiles([]))}>Cerrar</Button>
                </Modal.Footer>
            </Modal >

        </>
    )
}

export default ModalCreateGroup